// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import ProgramCount from "hooks/ProgramCount";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class GradesList extends Component {
  static propTypes = {
    // classes: PropTypes.object,
    grades: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedGrade, index) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedGrade, index);
    }
  }

  render() {
    const { grades } = this.props;

    return (
      <Table
        data={grades}
        meta={[
          {
            path: "name",
            title: "Name",
          },
          {
            path: "programCount",
            title: "Programs#",
            render: (t, d) => (
              <ProgramCount
                value={t}
                id={d.id}
                title={`${d.name} grade related programs`}
                type="grades"
              />
            ),
          },
        ]}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(GradesList);
